import React, { useState, useEffect, useRef } from "react";
import { Navigation } from "../Navigation/Navigation";
import { SmartSearch } from "../../Components/SmartSearch/SmartSearch";
import { TopbarBookingButton } from "../../Components/BookingButton/TopbarBookingButton";
import classnames from "classnames";
import { useThrottledCallback } from "use-debounce";
import { TopBarProps } from "./TopBarProps.csharp";

const scrollBelow = 87;

export const TopBar: React.FC<TopBarProps> = ({
  navigationProps,
  bookingButton,
  smartSearch,
}) => {
  const prevScrollPosRef = useRef(0);
  const [showTopBar, setShowTopBar] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleScroll = useThrottledCallback(() => {
    const currentScrollPos = window.scrollY;

    const scrollingDownAfterBreakpoint =
      currentScrollPos > prevScrollPosRef.current &&
      currentScrollPos > scrollBelow;

    if (scrollingDownAfterBreakpoint && showTopBar) {
      setShowTopBar(false);
    }

    if (!scrollingDownAfterBreakpoint && !showTopBar) {
      setShowTopBar(true);
    }

    prevScrollPosRef.current = currentScrollPos;
  }, 100);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={classnames("topbar", "sticky-top", {
        "slide-up": !showTopBar && !showMobileMenu,
      })}
    >
      <div className="container-fluid ps-xxl-0">
        <div className="d-flex">
          <div className="topbar__navbar-container">
            <Navigation
              {...navigationProps}
              showMobileMenu={showMobileMenu}
              setShowMobileMenu={setShowMobileMenu}
            />
          </div>
          <div className="topbar__booking-btn-container">
            {smartSearch && <SmartSearch {...smartSearch} />}
            <TopbarBookingButton bookingButton={bookingButton} />
          </div>
        </div>
      </div>
    </header>
  );
};
